<template>
  <div class="company-applyment-module" v-loading="loading" element-loading-custom-class="absolute-loading">
    <!-- 状态 -->
    <el-affix
      :class="{ 'applyment-page-header-top': affixed, 'applyment-page-header-shrink': sidebarFold, 'applyment-page-header-unfold': !sidebarFold }"
      @change="handleAffixChange"
      :offset="80"
    >
      <el-card>
        <div class="applyment-page-header">
          <div>
            <div class="status">
              {{ applymentStatusFormat(detail.applymentStatus) }}
            </div>
            <div class="page-header-heading-left">
              <div class="heading-title">Transaction No.: {{ detail.applymentNo }}</div>
            </div>
            <div class="page-header-heading-content">
              <el-descriptions :column="4" direction="vertical">
                <el-descriptions-item label="Transaction No.">{{ detail.applymentNo }}</el-descriptions-item>
                <el-descriptions-item label="Reviewer">
                  <template v-if="canUserToggle">
                    <user-toggle :user="detail.auditor" ownershipRole="auditor" />
                  </template>
                  <span v-else>{{ userNameFormat(detail.auditor) }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="Coordinator">
                  <template v-if="canUserToggle">
                    <user-toggle :user="detail.coordinator" ownershipRole="coordinator" />
                  </template>
                  <span v-else>{{ userNameFormat(detail.coordinator) }}</span>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
          <div class="page-header-heading-right">
            <div class="opts">
              <!-- 认领日志 -->
              <el-button type="text" icon="el-icon-tickets" @click="openOwnershipHistoryModal">Ownership History</el-button>
              <!-- 状态操作日志 -->
              <el-button type="text" icon="el-icon-tickets" @click="openStatusHistoryModal">Status Track</el-button>
              <!-- 提交报价单 -->
              <el-button
                v-if="detail.applymentStatus === 'QUOTING' && isApplymentAuth('quotation:coordinate')"
                type="primary"
                size="medium"
                :loading="submitLoading"
                @click="handleReviseFinish"
              >
                Revision Submit
              </el-button>
              <!-- 复核 -->
              <el-button
                v-if="detail.applymentStatus === 'QUOTATION_AUDITING' && isApplymentAuth('quotation:audit')"
                type="primary"
                size="medium"
                @click="handleAuditFinish"
              >
                Finish Review
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </el-affix>

    <!-- 基础信息 -->
    <div class="step mt50">
      <el-card shadow="hover">
        <base-info :detail="detail" ref="baseInfoRef" />
      </el-card>
    </div>

    <!-- Fee Letter -->
    <div id="Step2" class="step mt40">
      <el-card>
        <fee-letter ref="feeLetterRef" :detail="detail" @updateRevisionSubmitBtnLoading="updateRevisionSubmitBtnLoading"></fee-letter>
      </el-card>
    </div>

    <!-- 认领日志弹框 -->
    <ownership-history :applymentId="detail.id" ref="ownershipModal"></ownership-history>
    <!-- 状态操作日志弹框 -->
    <status-history :applymentId="detail.id" ref="statusHistoryModal"></status-history>
    <!-- 复核 - 弹框 -->
    <audit-modal ref="auditModal"></audit-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import UserToggle from "../components/UserToggle";
import BaseInfo from "../modules/baseInfo";
import FeeLetter from "../modules/feeLetter";
import OwnershipHistory from "./modal/OwnershipHistory.vue";
import StatusHistory from "./modal/StatusHistory.vue";
import AuditModal from "./modal/Audit.vue";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    BaseInfo,
    FeeLetter,
    UserToggle,
    StatusHistory,
    OwnershipHistory,
    AuditModal,
  },
  data() {
    return {
      affixed: false,
      submitLoading: false,
      loading: true,
    };
  },
  computed: {
    ...mapState("applyment", ["detail"]),
    ...mapState("authority", ["activeRoleName"]),
    ...mapState({
      userAt: state => {
        return { id: state.user.id, nickname: state.user.name, username: state.user.name };
      },
    }),
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
    // 是否可以切换复核(Reviewer)/业务(Coordinator)
    canUserToggle() {
      const list = ["INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"];
      return list.includes(this.detail.applymentStatus);
    },
  },
  watch: {
    activeRoleName(newVal) {
      // 权限认领弹框
      this.getTheTask();
    },
  },
  methods: {
    ...mapActions("applyment", ["initApplyment", "doClaimOwnership"]),
    ...mapMutations("applyment", ["RESET_APPLYMENT_STATE"]),
    handleAffixChange(fixed) {
      this.affixed = fixed;
    },
    // 详情
    async getDetail() {
      this.loading = true;
      try {
        await this.initApplyment(this.id);
        // 初始化基础信息组件
        await this.$nextTick();
        this.$refs?.baseInfoRef?.init();
        // 初始化Fee Letter组件
        this.$refs?.feeLetterRef?.init();
        // 权限认领弹框
        this.getTheTask();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    // 完成复核
    handleAuditFinish() {
      this.$refs.auditModal.init();
    },
    // 提交报价单（Revision Submit）
    handleReviseFinish() {
      this.$refs.feeLetterRef.dataFormSubmit();
    },
    // 更新 Revision Submit 按钮的loading状态
    updateRevisionSubmitBtnLoading(isOpen) {
      this.submitLoading = isOpen;
    },
    // 认领日志
    openOwnershipHistoryModal() {
      this.$refs.ownershipModal.init();
    },
    // 状态操作日志
    openStatusHistoryModal() {
      this.$refs.statusHistoryModal.init();
    },
    // 认领
    claim(type) {
      return this.doClaimOwnership({
        ownershipRole: type,
        toUser: this.userAt,
      }).then(() => {
        this.$message.success(`${type == "auditor" ? "reviewer" : type} success`);
      });
    },
    // 权限认领弹框
    async getTheTask() {
      if (
        !this.isAuth("quotation:adjust") &&
        ((this.isAuth("quotation:coordinate") && (!this.detail.coordinator || (this.detail.coordinator && this.detail.coordinator.id === -1))) ||
          // (this.isAuth("quotation:check") && (!this.detail.checker || (this.detail.checker && this.detail.checker.id === -1))) ||
          (this.isAuth("quotation:audit") && (!this.detail.auditor || (this.detail.auditor && this.detail.auditor.id === -1))))
      ) {
        let roleName = "";
        if (this.isAuth("quotation:coordinate") && (!this.detail.coordinator || (this.detail.coordinator && this.detail.coordinator.id === -1))) {
          roleName = "Coordinator";
        }
        // else if (this.isAuth("quotation:check") && (!this.detail.checker || (this.detail.checker && this.detail.checker.id === -1))) {
        //   roleName = "Checker";
        // }
        else if (this.isAuth("quotation:audit") && (!this.detail.auditor || (this.detail.auditor && this.detail.auditor.id === -1))) {
          roleName = "Reviewer";
        }
        await this.$confirm("Whether to pick up the work task of the application?", `Tasks Of ${roleName}`, {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info",
        });
        if (this.isAuth("quotation:coordinate") && (!this.detail.coordinator || (this.detail.coordinator && this.detail.coordinator.id === -1))) {
          await this.claim("coordinator");
        }
        // if (this.isAuth("quotation:check") && (!this.detail.checker || (this.detail.checker && this.detail.checker.id === -1))) {
        //   await this.claim("checker");
        // }
        if (this.isAuth("quotation:audit") && (!this.detail.auditor || (this.detail.auditor && this.detail.auditor.id === -1))) {
          await this.claim("auditor");
        }
      }
    },
  },
  activated() {
    // 先重置申请单详情(避免展示旧数据)
    this.RESET_APPLYMENT_STATE();
    // 请求申请单详情
    this.id = this.$route.params.id;
    this.getDetail();
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variables.scss";

.company-applyment-module {
  .applyment-page-header {
    background-color: #fff;
    // padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-header-heading-left {
      display: none;
    }

    .page-header-heading-content {
      width: 620px;
      padding-top: 12px;
    }

    .page-header-heading-right {
      .opts {
        display: inline-block;
      }
    }

    .status {
      display: inline-block;
      font-size: 20px;
      font-weight: bold;
      margin-right: 20px;
      color: #12a3ff;
      .fs12 {
        font-size: 12px;
      }
    }

    .status::before {
      display: inline-block;
      content: "";
      background: #12a3ff;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      vertical-align: middle;
      margin-right: 4px;
      margin-top: -4px;
    }
  }
  .applyment-page-header-top {
    .affix {
      z-index: 1030 !important;
    }
    .page-header-heading-left {
      display: inline-block;
    }
    .page-header-heading-content {
      display: none;
    }
    .status-label {
      display: none;
    }
  }

  .applyment-page-header-shrink {
    .affix {
      left: $sidebar-width !important;
      width: calc(100% - #{$sidebar-width} - 18px) !important;
    }
  }

  .applyment-page-header-unfold {
    .affix {
      left: $sidebar-full-width !important;
      width: calc(100% - #{$sidebar-full-width} - 18px) !important;
    }
  }

  .steps-bar-wrapper {
    position: fixed;
    right: 6px;
    top: 38vh;
    z-index: 1000;
  }

  .desp {
    color: rgb(53, 55, 68);

    .desp-header {
      font-size: 18px;
      padding: 10px 5px 10px;
      border-bottom: 1px solid #ebeef0;
      margin-bottom: 15px;
      color: #011a45;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
    }

    .desp-items-group {
      & + .desp-items-group {
        margin-top: 24px;
      }
    }

    .desp-items-group-title {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      border-left: 3px solid #eee;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-title-icon {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      color: #0060ff;
      // border-left: 3px solid #eee;
      background: #eceff9;
      margin-bottom: 15px;

      .title {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .desp-item {
      overflow: hidden;
    }

    .desp-item-label {
      width: 166px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #667288;
      line-height: 40px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
    }

    .desp-item-label:after {
      content: ":";
      position: relative;
      top: -0.5px;
      margin: 0 8px 0 2px;
    }

    .desp-item-content {
      margin-left: 100px;
      line-height: 40px;
      position: relative;
      font-size: 14px;
      color: #011a45;
    }

    .desp-item-self {
      width: 100%;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0 12px 0;
      box-sizing: border-box;
    }

    .desp-item-form {
      width: 100%;
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0;
      box-sizing: border-box;
    }
  }
}
</style>
